export default __webpack_public_path__ + "static/media/EconomicsSupplyDemand_06.cce01393.png";